/**
 * 右侧收藏组件
 * @author chenqunfneg
 * @since 18/06/11
 */
import React, { Component } from 'react';

import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';

import './nav-enterprice.less';

export default class NavCollection extends Component {
  render() {
    return (
      <div
        className="cmp nav-enterprice"
        title="企业会员免费领取"
        onClick={() => {
          window.open(`${window.RPCONFIG.mainHost}/service/`);
          sendStat(
            'RP_STORE',
            '模版市场',
            '右侧企业会员免费领取按钮',
            Stat.ACTION_CLICK,
            {
              id: 'web_mobanmarket_moban_rightqiye_click',
            }
          );
        }}>
        <i className="s-icon icon-apply" />
        <div>企业会员免费领取</div>
      </div>
    );
  }
}
